module.exports = __webpack_public_path__ + "img/start2.f0b3dca3.jpg";